import React, { createContext, useContext, useState } from 'react';

// Dev mode shows features that are hidden from partners. It's turned on and off
// by clicking the "Breez Portal" title five times.
// The choice is remembered in this browser.

const STORAGE_KEY = 'dev-preview';

interface DevPreviewContextType {
  devPreview: boolean;
  toggleDevPreview: () => boolean;
}

const DevPreviewContext = createContext<DevPreviewContextType>({
  devPreview: false,
  toggleDevPreview: () => false,
});

const readStored = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'on';
  } catch {
    return false;
  }
};

export const DevPreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [devPreview, setDevPreview] = useState(readStored);

  // Returns the new state
  const toggleDevPreview = () => {
    const next = !devPreview;
    setDevPreview(next);
    try {
      if (next) {
        localStorage.setItem(STORAGE_KEY, 'on');
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch {
      // Not remembered, e.g. with storage blocked
    }
    return next;
  };

  return (
    <DevPreviewContext.Provider value={{ devPreview, toggleDevPreview }}>
      {children}
    </DevPreviewContext.Provider>
  );
};

export const useDevPreview = () => useContext(DevPreviewContext);
